export const filterValues = [
  {
    identifier: "all",
    name: "Все",
  },
  {
    identifier: "tshirts",
    name: "Футболки",
  },
  {
    identifier: "sweatshirts",
    name: "Свитшоты",
  },
  {
    identifier: "swimwear",
    name: "Купальники",
  },
  {
    identifier: "top",
    name: "Топы",
  },
];
